import { useQuery } from '@tanstack/react-query'

import { getRegions } from '@/services/get-regions'

interface UseGetRegionsOptions {
  enabled?: boolean
}

export const GET_REGIONS_QUERY = 'regions'

export const useGetRegions = (
  project_id?: number,
  options?: UseGetRegionsOptions,
) => {
  return useQuery({
    queryKey: [GET_REGIONS_QUERY, project_id],
    queryFn: ({ signal }) => getRegions(project_id!, { signal }),
    enabled: !!project_id && (options?.enabled ?? true),
  })
}
